const errorTypes = {
  SERVER_ERROR: "SERVER_ERROR",
  CONNECTION_ABORTED: "CONNECTION_ABORTED",
  CONNECTION_ERROR: "CONNECTION_ERROR",
  CLIENT_ERROR: "CLIENT_ERROR",
  REQUEST_CANCELLED: "REQUEST_CANCELLED"
};

const invoiceProcessingErrorTypes = {
  ...errorTypes,
  INVALID_INVOICE_STATUS: "INVALID_INVOICE_STATUS",
  NOT_FOUND: "NO_RESULT"
};

export { errorTypes, invoiceProcessingErrorTypes };
